import { Observable } from 'rxjs';

const UploadFiles =  (dirHandle, artworks, projectId, $axios) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Observable( async (subscriber) => {
    try {
    let i = 0
    subscriber.next(0.0001);

    if (dirHandle !== null) {
      const directoryNames = [];

      for await (const entry of dirHandle.values()) {
        if (entry.kind === 'directory') {
          if (/^\d{1,2}_[-\w\s]+/.test(entry.name)) {
            directoryNames.push(entry.name);
          }
        }
      }
      directoryNames.sort();

      // delete first all layers
      await $axios({
        method: "DELETE",
        url: `/api/layers/${projectId}/delete-all`
      })

      for (const name of directoryNames) {
        for await (const entry of dirHandle.values()) {
          if (entry.kind === 'directory' && entry.name === name) {
            const arName = name.split('_')

            const formData = new FormData();
            formData.append('order', parseInt(arName[0]))

            arName.splice(0, 1)
            formData.append('name', arName.join(' '))

            formData.append('project_id', projectId)

            for await (const subentry of entry.values()) {
              if (subentry.kind === 'file') {
                const file = await subentry.getFile();
                if (file.type === 'image/png') {
                  formData.append("options", file)
                }
              }
            }

            await $axios({
              method: "POST",
              url: "/api/layers",
              data: formData,
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })

            i++
            subscriber.next(i);
          }
        }
      }
    }

    subscriber.complete();
  } catch (error) {
    subscriber.error(error)
  }
  })
}

const uploadSample = (artwork, projectId, $axios) =>  {
  fetch(artwork.link).then(data => {
    data.blob().then(b => {
      const file = new File([b], 'image.png', {type:"image/png", lastModified:new Date()});

      const formData = new FormData()
      formData.append("sample", file)
      formData.append('project_id', projectId)

      $axios({
        method: "PUT",
        url: `/api/sampletokens/${artwork.id}`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        artwork.hash = res.data.hash
        // artwork.link = res.data.link
      })
    })
  })
}

export {
  uploadSample,
  UploadFiles
};
